// src/project/data/triggers/saveNextPointReached.js
import { buildActionUrl, RIDER_ENDPOINTS } from '../config/apiConfig'

export default {
  postUrl(payload) {
    console.log('🚀 ~ payload:', payload)
    const itemData = payload.order || payload.delivery || payload
    const isPackage = itemData.type === 'package'
    const nextDest = itemData.nextDestination || {}
    const nextDestinationType = nextDest.type || itemData.nextDestinationType

    if (isPackage) {
      // Redirection vers l'endpoint timeline si l'action concerne un checkpoint
      if (
        nextDestinationType === 'checkpoint' ||
        nextDestinationType === 'pickup' ||
        nextDestinationType === 'checkpoint_reach' ||
        nextDestinationType === 'checkpoint_deliver'
      ) {
        return buildActionUrl(RIDER_ENDPOINTS.PACKAGE_TIMELINE)
      }
      return buildActionUrl(RIDER_ENDPOINTS.PACKAGE_STATUS)
    }

    if (nextDestinationType === 'pickup') {
      return buildActionUrl(RIDER_ENDPOINTS.ORDER_TIMELINE)
    }
    return buildActionUrl(RIDER_ENDPOINTS.ORDER_STATUS)
  },

  format(payload) {
    console.log('🚀 ~ payload:', payload)
    const itemData = payload.order || payload.delivery || payload
    const isPackage = itemData.type === 'package'
    const deliveryId = payload.deliveryId || itemData.id

    const nextDest = itemData.nextDestination || {}
    const nextDestinationType = nextDest.type || itemData.nextDestinationType

    // Coordonnées GPS
    const lat = payload.pos?.lat ?? payload.lat ?? null
    const lng = payload.pos?.lng ?? payload.lng ?? null

    // Détermination du statut exact à envoyer
    let status = 'in_transit'
    if (nextDestinationType === 'pickup') {
      status = 'pickup_reached'
    } else if (nextDestinationType === 'pickupDone') {
      status = 'picked_up'
    } else if (nextDestinationType === 'destination') {
      status = 'arrived'
    } else if (nextDestinationType === 'checkpoint_reach') {
      status = 'checkpoint_reached'
    } else if (nextDestinationType === 'checkpoint_deliver') {
      status = 'checkpoint_delivered'
    } else if (nextDestinationType === 'checkpoint') {
      status = 'checkpoint_reached'
    }

    let body = {
      packageId: deliveryId,
      orderId: deliveryId,
      newStatus: status,
      description: `${nextDest?.label ?? nextDestinationType} (${nextDest?.address ?? '-'}) atteint`,
      metadata: {},
    }

    // Si l'étape courante est un checkpoint, on constitue l'objet metadata.checkpoint
    const isCheckpointType =
      nextDestinationType === 'checkpoint' ||
      nextDestinationType === 'checkpoint_reach' ||
      nextDestinationType === 'checkpoint_deliver'

    if (isCheckpointType) {
      const checkpointPosition =
        nextDest.checkpointPosition ??
        itemData.nextDestinationCheckpointPosition ??
        0

      body.metadata.checkpoint = {
        id:
          nextDest.id ||
          itemData.nextDestinationId ||
          `checkpoint-${checkpointPosition}`,
        label:
          nextDest.label ||
          itemData.nextDestinationLabel ||
          `Checkpoint ${checkpointPosition + 1}`,
        address: nextDest.address || itemData.nextDestinationAddress || '',
        lat: nextDest.lat ?? itemData.nextDestinationLat ?? null,
        lng: nextDest.lng ?? itemData.nextDestinationLng ?? null,
        checkpointPosition: checkpointPosition,
        type: 'checkpoint',
      }
    }

    if (lat !== null) body.metadata.riderLat = lat
    if (lng !== null) body.metadata.riderLng = lng

    return body
  },

  parse(raw = {}) {
    if (raw?.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Le serveur semble inaccessible',
        data: raw?.data || null,
      }
    }
    return {
      statusCode: 200,
      message: raw?.message || 'ok',
      data: {
        saved: true,
        delivery: raw?.data || null,
      },
    }
  },
}
